<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="title">
                    <h1>공지사항 관리</h1>
                </div>
                <section>
                    <div class="row4">
                        <div class="btnBox blankLeft">
                            <button class="blueBtn smBtn">수정</button>
                            <button class="orangeBtn smBtn">삭제</button>
                        </div>
                        <hr class="hrNotice">
                        <div class="noticeWriteContainer">
                            <div class="headTxtContain">
                                <p>
                                    {{ headText }}
                                </p>
                            </div>
                            <div class="subTxtContain flex">
                                <p>
                                    <span>
                                        <strong>
                                            작성자
                                        </strong>
                                    </span>
                                    <span>
                                        {{ writer }}
                                    </span>
                                </p>
                                <p>
                                    <span>
                                        <strong>
                                            등록일
                                        </strong>
                                    </span>
                                    <span>
                                        {{ regdate }}
                                    </span>
                                </p>
                                <p>
                                    <span>
                                        <strong>
                                            조회수
                                        </strong>
                                    </span>
                                    <span>
                                        {{ countNo }}
                                    </span>
                                </p>
                                <div class="flex flexAlignC">
                                    <p>
                                        <span>첨부파일</span>
                                        
                                        <span class="attechFileImg">
                                            <strong>
                                                
                                            </strong>
                                            {{ fileName }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="textAreaContain">
                                <div class="noticeTxtBox">
                                    <p>
                                        {{ notiveTxtContents }}
                                    </p>
                                </div>
                            </div>
                            <div class="subBtnContain flex flexAlignS">
                                <a href="#" @click="listViewBtn()">목록</a>
                                <div class="prevNextBtnContain">
                                    <router-link to="">이전글</router-link>
                                    <router-link to="">다음글</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>   
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {
            totalNo: 1,
            nowPage: 1,
            totalPage: 2,
            perPage: 4,
            currentPage: 1,
            totalCnt: 0,
            // sample items
            items: [
                {
                    ID: '1',
                    STATUS: '<span class="notSubmit">미제출</span>',
                    SURVEYTITLE: '공지사항 입니다.공지사항 입니다.',
                    SURVEYDESCRIPT: '2021.06.04',
                    Count: '5',
                    REGDATE: '2021.06.23',
                    OUTDATE: '2021.06.24',
                    isActive: true
                },
                {
                    ID: '1',
                    STATUS: '미제출',
                    SURVEYTITLE: '공지사항 입니다.공지사항 입니다.',
                    SURVEYDESCRIPT: '2021.06.04',
                    Count: '5',
                    REGDATE: '2021.06.23',
                    OUTDATE: '2021.06.24',
                }
            ],
            //sortBy: 최초 보이는 화면의 sort 기준, sortDesc 순서
            sortBy: 'ID',
            sortDesc: false,
            fields: [
                {
                    key: 'ID',
                    label: 'No',
                    sortable: false,
                    sortDirection: 'desc',
                    class: 'text-center'
                },
                {
                    key: 'STATUS',
                    label: '상태',
                    sortable: false,
                    isActive: true,
                    class: 'statusOn text-center',
                },
                {
                    key: 'SURVEYTITLE',
                    label: '설문 제목',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'SURVEYDESCRIPT',
                    label: '설문지 설명',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'Count',
                    label: '조회수',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'REGDATE',
                    label: '등록일',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'OUTDATE',
                    label: '제출일',
                    sortable: false,
                    class: 'text-center'
                }
            ],
            headText: '공지사항입니다.',
            writer: '글쓴이',
            regdate: '2021.06.04',
            countNo: '5',
            fileName: '기타문서.pdf',
            notiveTxtContents: '공지를 합니다. 공지사항은 전화로 문의 바랍니다..',
        }
    },
    methods:{
        goback(){
            this.$router.go(-1) 
        },
        listViewBtn() {
            this.$router.push('/admin/noticeManagement');
        }
    }
}
</script>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>

<style scoped>
    .hrNotice {
        margin: 10px 0 0 0;
    }
</style>